// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name: string) => (
  <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  overview: getIcon('ic_overview'),
  cart: getIcon('ic_cart'),
  people: getIcon('ic_people'),
  home:getIcon('ic_home'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
};

const navConfig = [
  // BRAND
  // ----------------------------------------------------------------------
  {
    subheader: '',
    items: [
      {
        title: 'marke',
        path: PATH_DASHBOARD.brand("[brandID]").root,
        icon: ICONS.overview,
      },
    ],
  },

  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'allgemein',
    items: [
      {
        title: 'bestellungen',
        path: PATH_DASHBOARD.brand("[brandID]").store("[storeID]").orders.root,
        icon: ICONS.ecommerce,
        children: [
          { title: 'heute', path: PATH_DASHBOARD.brand("[brandID]").store("[storeID]").orders.today },
          { title: 'morgen', path: PATH_DASHBOARD.brand("[brandID]").store("[storeID]").orders.tomorrow },
        ],
      },
      { title: 'analyse', path: PATH_DASHBOARD.brand("[brandID]").store("[storeID]").analytics, icon: ICONS.analytics },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'management',
    items: [
      // PRODUCTS
      { title: 'produkte', path: PATH_DASHBOARD.brand("[brandID]").store("[storeID]").products.root, icon: ICONS.cart },

      // OPENING_HOURS
      { title: 'öffnungszeiten', path: PATH_DASHBOARD.brand("[brandID]").store("[storeID]").openingHours, icon: ICONS.calendar },

      // STORE
      { title: 'shop', path: PATH_DASHBOARD.brand("[brandID]").store("[storeID]").about, icon: ICONS.home },
    ],
  },
];

export default navConfig;
